import React from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: React.ReactNode;
}
export const LegalModal: React.FC<LegalModalProps> = ({
  isOpen,
  onClose,
  title,
  content
}) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-153">
      <div className="bg-white rounded-[20px] w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl animate-in fade-in zoom-in duration-200" data-id="element-154">
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-155">
          <h3 className="font-montserrat font-bold text-xl text-brand-dark" data-id="element-156">
            {title}
          </h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" data-id="element-157">
            <X size={20} className="text-gray-500" data-id="element-158" />
          </button>
        </div>

        <div className="p-6 overflow-y-auto font-inter text-gray-600 space-y-4" data-id="element-159">
          {content}
        </div>

        <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-[20px] flex justify-end" data-id="element-160">
          <button onClick={onClose} className="px-6 py-2 bg-brand-rose text-white rounded-lg font-medium hover:bg-[#6B1A3E] transition-colors" data-id="element-161">
            Close
          </button>
        </div>
      </div>
    </div>;
};